const numberFormatter = (
  n,
  factor,
  style, // it can be 'decimal', 'currency' and 'percent'
  fracDigits = 2,
  prefix = '',
  postfix = '',
  localeString = 'pt-BR',
  currency = 'BRL',
  currencyDisplay = 'symbol',
  intDigits = 1,
  zero = '-'
) => {
  if (isNaN(n)) {
    return zero
  }
  let factored = n / factor
  let options = {
    style,
    currency,
    currencyDisplay,
    minimumFractionDigits: fracDigits,
    maximumFractionDigits: fracDigits,
    minimumIntegerDigits: intDigits
  }
  let formatted = factored.toLocaleString(localeString, options)
  let zeroTemplate = Number(0).toLocaleString(localeString, options)
  return formatted === zeroTemplate ? zero : prefix + formatted + postfix
}

const timestampFormatter = (
  timestampObj,
  locale = 'pt-BR',
  timezone = 'America/Sao_Paulo'
) => {
  let date = new Date(1970, 0, 1)
  date.setSeconds(timestampObj.seconds)
  return date.toLocaleDateString(locale, { timezone })
}

export default {
  numberFormatter,
  timestampFormatter
}
